const dashboardSwedish = {
  greeting: {
    morning: "God morgon",
    afternoon: "God eftermiddag",
    evening: "God kväll"
  },
  recentActivity: {
    title: "Senaste Aktivitet",
    empty: "Ingen aktivitet att visa än"
  },
  notifications: {
    title: "Aviseringar",
    loading: "Laddar aviseringar...",
    newPost: "Nytt LinkedIn-inlägg klart!",
    seeAll: "Se alla {count} inlägg",
    empty: "Inga aviseringar att visa"
  }
};

export default dashboardSwedish; 